<script setup lang="ts">
import { ref, watch } from 'vue'
import { type UserInfoPayload, updateUserInfoAction } from '@/api/functions/users/user-info-actions'
import { useMutationApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'

const props = defineProps({
  userData: { type: Object },
  uuid: { type: String, required: true },
})

const toast = useToast()

const firstName = ref('')
const lastName = ref('')
const firstNameEn = ref('')
const lastNameEn = ref('')
const birthDate = ref('')
const gender = ref('')
const isSaving = ref(false)

watch(
  () => props.userData,
  (newVal) => {
    if (!newVal) return
    firstName.value = newVal.first_name ?? ''
    lastName.value = newVal.last_name ?? ''
    firstNameEn.value = newVal.first_name_en ?? ''
    lastNameEn.value = newVal.last_name_en ?? ''
    birthDate.value = newVal.birth_date ?? ''
    gender.value = newVal.gender ?? ''
  },
  { immediate: true }
)

const mutation = useMutationApi({
  mutationFn: (payload: UserInfoPayload) => updateUserInfoAction(props.uuid, { ...payload }),
  onMutate: () => {
    isSaving.value = true
    toast.info('در حال بروزرسانی...')
  },
  onSuccess: () => {
    isSaving.value = false
    toast.success('اطلاعات تکمیلی کاربر با موفقیت ذخیره شد')
  },
  onError: (error: Error) => {
    isSaving.value = false
    toast.error(getErrorMessage(error))
  },
})

const handleSave = () => {
  mutation.mutate({
    first_name: firstName.value,
    last_name: lastName.value,
    first_name_en: firstNameEn.value,
    last_name_en: lastNameEn.value,
    birth_date: birthDate.value || null,
    gender: gender.value,
  })
}
</script>

<template>
    <div class="bg-white rounded-xl p-5 lg:p-8">
        <span class="text-[#2d5396] text-sm">اطلاعات تکمیلی کاربر:</span>
        <div class="grid lg:grid-cols-4 gap-6 mt-6" :key="props.userData?.uuid">
            <Input v-model="firstName" name="first_name" label="نام" type="text" />
            <Input v-model="lastName" name="last_name" label="نام خانوادگی" type="text" />
            <Input v-model="firstNameEn" name="first_name_en" label="نام لاتین" type="text" />
            <Input v-model="lastNameEn" name="last_name_en" label="نام خانوادگی لاتین" type="text" />

            <AlirezaDatePicker v-model="birthDate" label="تاریخ تولد" placeholder="تاریخ تولد" />

            <Select variant="checkbox" v-model="gender" label="جنسیت" :options="[
                { label: 'زن', value: 'female' },
                { label: 'مرد', value: 'male' }
            ]" />

            <div></div>

            <div class="flex justify-end">
                <Button @click="handleSave" :loading="isSaving" :disabled="isSaving" type="button" label="ثبت و ذخیره"
                    :isAdmin="true" class="w-fit px-6! h-12! rounded-xl" />
            </div>
        </div>
    </div>
</template>
